import React, { FC } from 'react';
import {
  BadgePreviewRenderer,
  getPlaceholderData,
  transformNodeMap,
} from '../badgerenderer/BadgeRender';
import { FormContext, FormStateType } from '../form/FormReducer';

interface BadgePreviewRendererProps {
  readonly state: FormStateType;
  readonly context: FormContext;
}

export const BadgePreview: FC<BadgePreviewRendererProps> = ({ context, state }) => {
  const { user } = context;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (state.type !== 'registration' || !context.badgeDesign || !context.product) {
    return null;
  }

  const speciesOption = context.speciesOptionId;
  const species = speciesOption && state.options[speciesOption];

  const label = getPlaceholderData({
    attendanceType: context.product,
    badgeArtId: state.badgeArtId,
    badgeName: state.badgeName,
    options: state.options,
    species: (species as string | undefined) ?? '',
    user,
  });

  return (
    <BadgePreviewRenderer
      image={state.badgeArtId ? `/api/badgeart/${state.badgeArtId}/image` : ''}
      label={label}
      nodes={transformNodeMap(context.badgeDesign)}
    />
  );
};
